import { Form } from 'antd';
import React from 'react'
import FormSupportProvider from './FormSupportProvider';

const SearchSupportProvider: React.FC<any> = ({
    getList,
    setPaginationData
}) => {
    const [form] = Form.useForm();
    const handleSearchSubmit = (data?: any) => {
        const payload = {
            ...data,
            pageNumber: 1,
            pageSize: 10,
        }
        setPaginationData({
            pageNumber: 1,
            pageSize: 10,
        })
        getList(payload)
    }
    return (
        <FormSupportProvider
            form={form}
            handleSearchSubmit={handleSearchSubmit}
            mode={'search'}
        />
    )
}

export default SearchSupportProvider